// extracted by mini-css-extract-plugin
module.exports = {"root":"Stepper_root__zHPOx","rootWrapper":"Stepper_rootWrapper__If2K_"};